import { adminCustomersLockAllUsersPostSlice } from './post';
import { combineAllWatchers } from '@sonar-software/xuder';
import { combineReducers } from 'redux';

export const adminCustomersLockAllUsersReducers = combineReducers({
	post: adminCustomersLockAllUsersPostSlice.asyncReducers
});

export const adminCustomersLockAllUsersWatchers = combineAllWatchers([
	adminCustomersLockAllUsersPostSlice.asyncWatchers
]);
